<template>
	<app-content class="h-panel">
		<div class="h-panel-bar"><span class="h-panel-title">自动转账模板</span></div>
		<div class="margin-top margin-left margin-right-left">
			<Button color="primary" @click="openForm()">新增模板</Button>
			<Button color="primary" @click="openExecute">生成凭证</Button>
			<span class="tips dark4-color">用于计提、摊销、折旧等每月固定模式的凭证，配置取数公式后一键生成</span>
		</div>
		<div class="h-panel-body">
			<Table :datas="datas" :border="true">
				<TableItem title="模板名称" prop="name"></TableItem>
				<TableItem title="凭证字" prop="word" :width="80"></TableItem>
				<TableItem title="摘要" prop="summary"></TableItem>
				<TableItem title="状态" :width="80">
					<template slot-scope="{data}">
						{{data.enabled === 1 ? '启用' : '停用'}}
					</template>
				</TableItem>
				<TableItem title="操作" :width="200" align="center">
					<div class="actions" slot-scope="{data}">
						<span @click="openForm(data)">编辑</span>
						<span @click="executeOne(data)">执行</span>
						<span @click="remove(data)">删除</span>
					</div>
				</TableItem>
			</Table>
		</div>

		<Modal v-model="formModal" :width="900" hasCloseIcon>
			<div slot="header">{{form.id ? '编辑自动转账模板' : '新增自动转账模板'}}</div>
			<Form :labelWidth="80">
				<Row type="flex" :space-x="15">
					<Cell>
						<FormItem label="模板名称" required>
							<input type="text" v-model="form.name" style="width:220px;" placeholder="如：计提本月折旧">
						</FormItem>
					</Cell>
					<Cell>
						<FormItem label="凭证字" required>
							<Select keyName="word" titleName="word" v-model="form.word" style="min-width:90px;" :datas="voucherWords" :deletable="false"/>
						</FormItem>
					</Cell>
					<Cell>
						<FormItem label="凭证摘要" required>
							<input type="text" v-model="form.summary" style="width:220px;" placeholder="生成凭证时使用">
						</FormItem>
					</Cell>
					<Cell>
						<FormItem label="状态">
							<Radio type="button" v-model="form.enabled" :datas="enabledDatas"></Radio>
						</FormItem>
					</Cell>
				</Row>
			</Form>
			<div class="margin-top">
				<Button size="s" @click="addRow">添加一行</Button>
			</div>
			<table class="h-table tpl-table margin-top">
				<tr>
					<th style="width:240px;">科目</th>
					<th style="width:90px;">方向</th>
					<th style="width:150px;">取数方式</th>
					<th style="width:130px;">固定金额</th>
					<th style="width:110px;">比例(%)</th>
					<th style="width:70px;">平衡行</th>
					<th style="width:60px;">操作</th>
				</tr>
				<tr v-for="(row,i) in form.details" :key="i">
					<td>
						<Select v-model="row.subjectId" filterable @change="onSubjectChange(row)">
							<Option v-for="s in leafSubjects" :value="s.id" :key="s.id">{{s.code}}-{{s.name}}</Option>
						</Select>
					</td>
					<td>
						<Radio type="button" v-model="row.direction" :datas="directionDatas"></Radio>
					</td>
					<td>
						<Select v-model="row.amountType">
							<Option v-for="a in amountTypeDatas" :value="a.key" :key="a.key">{{a.title}}</Option>
						</Select>
					</td>
					<td>
						<NumberInput v-if="row.amountType===0" v-model="row.amount" :min="0" :precision="2" v-width="110"/>
					</td>
					<td>
						<NumberInput v-if="row.amountType!==0" v-model="row.ratio" :min="0" :max="100" :precision="2" v-width="90"/>
					</td>
					<td>
						<input type="checkbox" :checked="row.balanceFlag===1" @change="onBalanceChange(row, $event)" :disabled="row.amountType===0">
					</td>
					<td><span class="text-hover" @click="removeRow(i)">删除</span></td>
				</tr>
				<tr v-if="!form.details.length">
					<td colspan="7" class="text-center padding">请添加分录行</td>
				</tr>
			</table>
			<div class="dark4-color margin-top" style="font-size:12px;">
				说明：取数按目标期间统计，含下级科目；「平衡行」自动取借贷差额，最多设置一行；固定金额行不能作为平衡行。
			</div>
			<div class="text-center margin-top">
				<Button color="green" :loading="loading" @click="submit">保存</Button>
				<Button @click="formModal=false">取消</Button>
			</div>
		</Modal>

		<Modal v-model="executeModal" :width="560" hasCloseIcon>
			<div slot="header">生成自动转账凭证</div>
			<Form :labelWidth="80">
				<FormItem label="会计期间" required>
					<Select v-model="execute.year" style="width:100px;">
						<Option v-for="y in yearOptions" :value="y" :key="y">{{y}}年</Option>
					</Select>
					<Select v-model="execute.month" style="width:90px;margin-left:8px;">
						<Option v-for="m in 12" :value="m" :key="m">{{m}}月</Option>
					</Select>
				</FormItem>
				<FormItem label="选择模板" required>
					<table class="h-table" style="width:100%;">
						<tr v-for="t in datas" :key="t.id">
							<td style="width:40px;">
								<input type="checkbox" :checked="execute.ids.includes(t.id)" @change="toggleExecute(t.id, $event)" :disabled="t.enabled !== 1">
							</td>
							<td>{{t.name}}</td>
							<td>{{t.word}}</td>
						</tr>
					</table>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button @click="executeModal=false">取消</Button>
				<Button color="primary" :loading="loading" @click="doExecute">执行生成</Button>
			</div>
		</Modal>
	</app-content>
</template>

<script>
	import moment from 'moment';
	import {mapState} from 'vuex';

	const emptyRow = () => ({
		subjectId: null, subjectCode: '', subjectName: '',
		direction: 1, amountType: 1, amount: null, ratio: 100, balanceFlag: 0
	});

	export default {
		name: 'AutoTransfer',
		data() {
			let now = new Date();
			return {
				datas: [],
				voucherWords: [],
				leafSubjects: [],
				formModal: false,
				executeModal: false,
				loading: false,
				form: {id: null, name: '', word: '', summary: '', enabled: 1, details: []},
				enabledDatas: [{key: 1, title: '启用'}, {key: 0, title: '停用'}],
				directionDatas: [{key: 1, title: '借'}, {key: 2, title: '贷'}],
				amountTypeDatas: [
					{key: 0, title: '固定金额'},
					{key: 1, title: '期末余额'},
					{key: 2, title: '本期借方发生'},
					{key: 3, title: '本期贷方发生'}
				],
				execute: {year: now.getFullYear(), month: now.getMonth() + 1, ids: []}
			};
		},
		computed: {
			...mapState(['currentAccountSets']),
			yearOptions() {
				let y = this.currentPeriod().year;
				return [y - 2, y - 1, y, y + 1];
			}
		},
		methods: {
			//取当前账套期间作为默认生成期间，与凭证列表/录入保持一致
			currentPeriod() {
				let base = this.currentAccountSets && this.currentAccountSets.currentAccountDate
					? moment(this.currentAccountSets.currentAccountDate) : moment();
				return {year: base.year(), month: base.month() + 1};
			},
			loadList() {
				this.$api.voucher.autoTransfer.list().then(({data}) => {
					this.datas = data || [];
				});
			},
			loadMeta() {
				this.$api.setting.voucherWord.list().then(({data}) => {
					this.voucherWords = data || [];
				});
				this.$api.setting.subject.allList().then(({data}) => {
					let flat = this.flattenSubjects(data || []);
					this.leafSubjects = flat.filter(s => !flat.some(t => t.code !== s.code && t.code.indexOf(s.code) === 0));
				});
			},
			flattenSubjects(nodes, out = []) {
				(nodes || []).forEach(n => {
					if (n.id) {
						out.push({id: n.id, code: n.code, name: n.name});
					}
					if (n.children && n.children.length) {
						this.flattenSubjects(n.children, out);
					}
				});
				return out;
			},
			openForm(data) {
				if (data && data.id) {
					this.$api.voucher.autoTransfer.get(data.id).then(({data}) => {
						data.details = (data.details || []).map(d => Object.assign(emptyRow(), d));
						this.form = data;
						this.formModal = true;
					});
				} else {
					this.form = {id: null, name: '', word: '', summary: '', enabled: 1, details: [emptyRow(), emptyRow()]};
					let def = this.voucherWords.find(v => v.isDefault);
					if (def) this.form.word = def.word;
					this.formModal = true;
				}
			},
			addRow() {
				this.form.details.push(emptyRow());
			},
			removeRow(i) {
				this.form.details.splice(i, 1);
			},
			onSubjectChange(row) {
				let s = this.leafSubjects.find(v => v.id === row.subjectId);
				if (s) {
					row.subjectCode = s.code;
					row.subjectName = s.name;
				}
			},
			onBalanceChange(row, e) {
				if (e.target.checked) {
					this.form.details.forEach(r => r.balanceFlag = 0);
					row.balanceFlag = 1;
					row.amountType = 1;
				} else {
					row.balanceFlag = 0;
				}
			},
			validate() {
				if (!this.form.name.trim()) return '请输入模板名称';
				if (!this.form.word) return '请选择凭证字';
				if (!this.form.summary.trim()) return '请输入凭证摘要';
				if (this.form.details.length < 2) return '至少配置两条分录';
				let balanceCount = 0;
				for (let i = 0; i < this.form.details.length; i++) {
					let r = this.form.details[i], label = `第${i + 1}行`;
					if (!r.subjectId) return `${label}请选择科目`;
					if (!r.direction) return `${label}请选择方向`;
					if (r.amountType === 0) {
						if (!(r.amount > 0)) return `${label}固定金额必须大于0`;
					} else {
						if (!(r.ratio > 0)) return `${label}比例必须大于0`;
					}
					if (r.balanceFlag === 1) {
						balanceCount++;
						if (r.amountType === 0) return '固定金额行不能作为平衡行';
					}
				}
				if (balanceCount > 1) return '平衡行最多只能设置一条';
				return null;
			},
			submit() {
				let err = this.validate();
				if (err) {
					this.$Message(err);
					return;
				}
				this.loading = true;
				this.$api.voucher.autoTransfer.save(this.form).then(() => {
					this.$Message('保存成功');
					this.formModal = false;
					this.loadList();
				}).finally(() => {
					this.loading = false;
				});
			},
			remove(data) {
				this.$Confirm(`确认删除模板「${data.name}」?`).then(() => {
					this.$api.voucher.autoTransfer.delete(data.id).then(() => {
						this.$Message('删除成功');
						this.loadList();
					});
				});
			},
			openExecute() {
				let p = this.currentPeriod();
				this.execute.year = p.year;
				this.execute.month = p.month;
				this.execute.ids = [];
				this.executeModal = true;
			},
			toggleExecute(id, e) {
				if (e.target.checked) {
					this.execute.ids.push(id);
				} else {
					this.execute.ids = this.execute.ids.filter(v => v !== id);
				}
			},
			doExecute() {
				if (!this.execute.ids.length) {
					this.$Message('请选择要执行的模板');
					return;
				}
				this.loading = true;
				this.$api.voucher.autoTransfer.execute({
					templateIds: this.execute.ids,
					year: this.execute.year,
					month: this.execute.month
				}).then(({data}) => {
						this.$Message(Array.isArray(data) ? `执行完成，生成凭证${data.length}张` : '执行完成');
						this.executeModal = false;
					}).finally(() => {
					this.loading = false;
				});
			},
			executeOne(data) {
				if (data.enabled !== 1) {
					this.$Message('该模板已停用');
					return;
				}
				let p = this.currentPeriod();
				this.$Confirm(`确认执行模板「${data.name}」，生成${p.year}年${p.month}期凭证?`).then(() => {
					this.loading = true;
					this.$api.voucher.autoTransfer.execute({
						templateIds: [data.id],
						year: p.year,
						month: p.month
					}).then(() => {
						this.$Message('执行成功');
					}).finally(() => {
						this.loading = false;
					});
				});
			}
		},
		mounted() {
			this.loadList();
			this.loadMeta();
		}
	};
</script>

<style lang='less' scoped>
	.tips {
		margin-left: 12px;
		font-size: 12px;
	}

	.tpl-table {
		:global(.h-select) {
			width: 100%;
		}
	}
</style>
